import React, { useEffect, useState, useContext } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import Loader from '@components/loader/1'
import parse from 'html-react-parser'
import FormJobs from '@components/form/2'
import AccordionContext from 'react-bootstrap/AccordionContext'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import { useGetJobsQuery } from '@apis/mediacore/jobs'
import { ElementHTML } from '@helpers/helper.rendering'

interface CTXAccordion {
  children?: any
  eventKey: string
  callback?: Function
  formState?: any
}

const ContextAwareToggle = ({ children, eventKey, callback, formState }: CTXAccordion) => {
  const { activeEventKey } = useContext(AccordionContext)

  const decoratedOnClick = useAccordionButton(eventKey, () => {
    callback && callback(eventKey)
    formState?.showForm && formState?.setShowForm(false)
  })

  const isCurrentEventKey = activeEventKey === eventKey

  return (
    <div
      className="accordion-header d-flex justify-content-between align-itmes-center cursor-pointer card-header-wrapper"
      onClick={decoratedOnClick}
    >
      {children}
      <i className={'m-1 icon-arrow-light ' + (isCurrentEventKey ? 'up' : 'down')}></i>
    </div>
  )
}

const MediaJobs = (props: RealEstateDataPageComponentData) => {
  const {
    image,
    title,
    subtitle,
    form,
    global_data,
    item,
    alignCenter,
    titleColor,
    titleHexa,
    subtitleColor,
    subtitleHexa,
    customBorderRadius,
    titleElement,
    subtitleElement,
    paragraphElement,
    paragraph,
  } = props

  const siteId = global_data.id

  const { data: allJobsData } = useGetJobsQuery({ site: siteId })

  // Loader effect
  const [showForm, setShowForm] = useState(false)
  const [currentActive, setCurrentActive] = useState<any>(null)
  const [load, setLoad] = useState(false)

  // Custom CTA Btn x2
  const ctaBtn = (jobId: number) => (
    <>
      <button
        className="btn btn-primary inverted-on-open"
        onClick={() => handleClick(jobId)}
      >
        Postularme
      </button>
    </>
  )

  // Promise for handleClick > 1st show form, then scrollIntoView
  const handleClick = (jobId: number) => {
    new Promise<void>((resolve) => {
      setShowForm(true)
      resolve()
    }).then(() => {
      setTimeout(() => {
        if (document) {
          document
            ?.querySelector(`#form-id-${jobId}`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 500)
    })
  }

  return (
    <section
      id="media-jobs"
      className={
        'jobs' +
        (image ? ' img-top' : ' not-img-top') +
        (allJobsData?.length === 0 ? ' d-none' : '')
      }
    >
      {!load ? (
        <>
          {image ? (
            <img
              src={image}
              alt={title}
              className="media-jobs-img w-100 object-fit-cover"
            />
          ) : null}
          <Container fluid>
            <Row>
              <Col xs={12}>
                {/* <h2
                  className={`section-title pb-lg-5 pt-5 ${
                    alignCenter ? ' text-center pb-4' : ''
                  } ${titleColor}`}
                  style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                >
                  {title}
                </h2> */}
                <ElementHTML
                  children={title}
                  elementType={titleElement || 'h2'}
                  className={`section-title pb-lg-5 pt-5 ${
                    alignCenter ? ' text-center pb-4' : ''
                  } ${titleColor}`}
                  style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                />
              </Col>
              <Col xs={12}>
                {/* <p
                  className={'section-subtitle pb-lg-5' + (alignCenter ? ' text-center pb-4' : '')}
                >
                  {subtitle}
                </p> */}
                <ElementHTML
                  children={subtitle}
                  elementType={subtitleElement || 'p'}
                  className={'section-subtitle pb-lg-5' + (alignCenter ? ' text-center pb-4' : '')}
                />
              </Col>
              <Col xs={12}>
                <ElementHTML
                  style={{ color: subtitleColor === 'text-picker' ? subtitleHexa : '' }}
                  children={(paragraph || 'Búsquedas activas: ') + allJobsData?.length}
                  elementType={paragraphElement || 'h5'}
                  className={`counter mt-4 ${alignCenter ? 'text-center' : ''} ${subtitleColor}`}
                />
                {/* <h5
                  className={`counter mt-4 ${alignCenter ? 'text-center' : ''} ${subtitleColor}`}
                  style={{ color: subtitleColor === 'text-picker' ? subtitleHexa : '' }}
                ></h5> */}
              </Col>
            </Row>
            <div className="jobs-wrapper my-4">
              <Accordion
                onSelect={(e) => setCurrentActive(e?.toString())}
                flush
              >
                {allJobsData && allJobsData?.length > 0
                  ? allJobsData?.map((job, i) => (
                      <Accordion.Item
                        className={
                          (currentActive !== i.toString() && currentActive ? 'opacity' : '') +
                          (showForm ? ' form-open' : '')
                        }
                        eventKey={String(i)}
                        key={i}
                      >
                        <ContextAwareToggle
                          eventKey={String(i)}
                          formState={{ showForm, setShowForm }}
                        >
                          <div className="d-flex flex-column">
                            <h5 className="position mb-1">{`${job.name} ${
                              job.experience_level !== 'Sin especificar'
                                ? `${job.experience_level}`
                                : ''
                            }`}</h5>
                            <p className="location">{`${job.mode} ${
                              job.mode === 'Presencial' || job.mode === 'Híbrida'
                                ? ` -  ${job.location}`
                                : ''
                            }`}</p>
                          </div>
                        </ContextAwareToggle>
                        <Accordion.Body className="px-0 description">
                          {job.description && (
                            <div className="description-container">{parse(job.description)}</div>
                          )}
                          {ctaBtn(job.id!)}
                          <FormJobs
                            jobData={job}
                            global_data={global_data}
                            stateProp={showForm}
                            closeBtnAction={() => setShowForm(false)}
                            item={item!}
                            customBorderRadius={customBorderRadius}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                    ))
                  : null}
              </Accordion>
            </div>
          </Container>
        </>
      ) : (
        <Loader />
      )}
    </section>
  )
}

export default MediaJobs
